import React, { ComponentProps } from 'react';
import { Modal as RSModal } from 'reactstrap';
import { CancelButton } from 'src/components/Buttons';
import { OkButton } from 'src/components/Buttons/OkButton';
import { GenericDialog } from 'src/core/interim/dialogs/GenericDialog';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export type ConfirmDialogProps = {
  onOkay?: () => void;
  headerText: React.ReactNode;
  bodyText: React.ReactNode;
  onCancel?: () => void;
  cancelText?: ContentId;
  okText?: ContentId;
  disabled?: boolean;
  isLoading?: boolean;
} & ComponentProps<typeof RSModal>;

export function ConfirmDialog({
  headerText,
  bodyText,
  onCancel,
  onOkay,
  okText,
  cancelText,
  isOpen,
  disabled,
  isLoading,
  ...rest
}: ConfirmDialogProps) {
  return (
    <GenericDialog
      header={headerText}
      footer={
        <>
          {onCancel && (
            <CancelButton
              disabled={disabled || isLoading}
              textContentId={cancelText}
              onClick={onCancel}
            />
          )}
          {onOkay && (
            <OkButton
              disabled={disabled || isLoading}
              textContentId={okText}
              onClick={onOkay}
            />
          )}
        </>
      }
      {...rest}
      isOpen={isOpen}
      onCancel={onCancel}
    >
      <Stack direction="column" gap="l" width="full" alignItems="center">
        {bodyText}
        {isLoading && <PosSpinner />}
      </Stack>
    </GenericDialog>
  );
}
